import { gql } from "@apollo/client";

export const GetSchools = gql`
  query TaWeb_GetSchools($pagination: PaginationInputs) {
    me {
      schools(pagination: $pagination) {
        id
        name
        location {
          country
        }
        contracts {
          id
          status
          endsAt
          applications {
            name
          }
          products {
            id
            name
          }
        }
      }
      classrooms(pagination: $pagination) {
        id
        name
        courses {
          level
          product {
            name
            id
            maxLevel
            baseLevel
          }
        }
      }
    }
  }
`;

// A school's name from its id (the access settings list some by id only)
export const GetSchoolName = gql`
  query TaWeb_GetSchoolName($id: ID!) {
    getSchool(id: $id) {
      id
      name
    }
  }
`;

export const GetAllSchools = gql`
  query TaWeb_GetAllSchools(
    $filter: SchoolFilterInputs
    $pagination: PaginationInputs
  ) {
    getSchools(filter: $filter, pagination: $pagination) {
      name
      id
    }
  }
`;
